import { render, staticRenderFns } from "./FinalizeLicenses.vue?vue&type=template&id=fa2bd202&scoped=true&"
import script from "./FinalizeLicenses.vue?vue&type=script&lang=js&"
export * from "./FinalizeLicenses.vue?vue&type=script&lang=js&"
import style0 from "./FinalizeLicenses.vue?vue&type=style&index=0&id=fa2bd202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2bd202",
  null
  
)

export default component.exports